import React, { useState } from "react";
import AdditionalChargesModal from "./AdditionalChargesModal";
import PickingConfirmation from "./PickingConfirmation";
import BillingQuantitiesModal from "src/components/capture/ReceivingWizard/Shipment/Billing/BillingQuantitiesModal";

export default function OutboundBillingModal({
  initialStep,
  inventoryRequest,
  billingType,
  hasAdditionalCharges,
  onClose,
  palletTypes,
  unitTypes,
}) {
  const inventoryRequestId = inventoryRequest.id;
  const [step, setStep] = useState(initialStep);

  const handleAdditionalChargesComplete = () => {
    setStep("confirmation");
  };

  const handlePickingConfirmationClose = () => {
    setStep(initialStep);
    onClose();
  };

  const handleAdditionalChargesClose = () => {
    onClose();
  };

  switch (step) {
    case "quantities":
      return (
        <BillingQuantitiesModal
          type="Outbound"
          billingType={billingType}
          shipment={inventoryRequest}
          palletTypes={palletTypes}
          unitTypes={unitTypes}
          onSave={() => setStep(hasAdditionalCharges ? "charges" : "confirmation")}
          onClose={onClose}
        />
      );
    case "charges":
      return (
        <AdditionalChargesModal
          inventoryRequestId={inventoryRequestId}
          inventoryRequest={inventoryRequest}
          inventoryItems={inventoryRequest.inventoryItems || []}
          onClose={handleAdditionalChargesClose}
          currentItemIndex={
            (inventoryRequest.inventoryItems || []).filter(item => item.pickedStatus).length
          }
          onSubmit={handleAdditionalChargesComplete}
        />
      );
    case "confirmation":
      return <PickingConfirmation onClose={handlePickingConfirmationClose} />;
  }
}
